var $ = jQuery;

var a = document.querySelector('.mcl-hero-cta button');

var b = document.querySelector('#mcl-teaching-section');

if(b) {
    a.addEventListener('click', (e) => {
        e.preventDefault();
        b.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });

    });

}




// WEBPACK FOOTER //
// ./src/layouts/courses-detail/course-detail.js